import { render, staticRenderFns } from "./AssignTableLamps.vue?vue&type=template&id=43a91bba&scoped=true&"
import script from "./AssignTableLamps.vue?vue&type=script&lang=ts&"
export * from "./AssignTableLamps.vue?vue&type=script&lang=ts&"
import style0 from "./AssignTableLamps.vue?vue&type=style&index=0&id=43a91bba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a91bba",
  null
  
)

export default component.exports